module.exports = __webpack_public_path__ + "static/media/charcoal.f9b16100.mp3";